export default __webpack_public_path__ + "static/media/lil-nouners-bg.bd0900be.png";